const paths = {
  projectFormApi: "/new-project",
  projectEquipsApi: "/project-equipments",
  myProjects: "/projects",
  myEstimation: "/estimation",
  myMaterialRecords: "/material-records",
  getAProject: "/projects/:projectId/:tab",
  EquipmentsApi: "equipments",
  vendorScreen: "/vendor",
  vendorMrqs: "/vendor-mrqs/:token",
  vendorPos: "/vendor-pos/:token",
  vendorDocTransmittal: "/doc-transmittal/external/:token",
  vendorBidChat: "/vendor-bid-chat/:token",
  clientVendors: "/client-vendors-page",
  materialsDB: "/materials-database",
  scm: "/supply-chain-management",

  adminPanel: "/admin-panel",
  licenceManagement: "/licence-management",
  mytasks: "/mytasks",
  allstaff: "/allstaff",
  main_pv: "/projects/:id/equipments/main_pv/:equipId",
  main_pv_tabs: "/projects/:id/equipments/main_pv/:equipId/*",
  softwares: "/softwares",
  onboarding: "/onboarding",
  ams: "/ams",
  plant: "/plant",
  plantPage: "/plant/:plantId",
  plantOpen: "/plant/:plantId/open",
  plantEstimation: "/plant/:plantId/estimation",
  plantDCS: "/plant/:plantId/dcs",
  plantPCS: "/plant/:plantId/pcs",
  plantMCS: "/plant/:plantId/mcs",
  plantPMS: "/plant/:plantId/pms",
  plantTask: "/plant/:plantId/task",
  plantMIS: "/plant/:plantId/mis",
  plantCMS: "/plant/:plantId/cms",
  plantValidation: "/plant/:plantId/validation",
  plantDocRegister: "/plant/:plantId/document-register",
  plantMRQ: "/plant/:plantId/mrq",
  plantVendorBidEvaluation: "/plant/:plantId/vendor-bid-evaluation",
  plantPO: "/plant/:plantId/po",
  plantMRV: "/plant/:plantId/mrv",
  plantSRV: "/plant/:plantId/srv",
  emsExplorer: "/ems-explorer",
};

export default paths;

// const data = {
//   design: {
//     shellTab: {
//       shellGridView: [
//         {
//           component: "Head",
//         },
//         {
//           component: "Shell",
//         },
//       ],
//     },
//   },
// };
